import { CategoryType } from './Category';
export var WORKSPACE_ID = {
    firstParty: 'office-365-apps',
    moreFromM365: 'more-m365-apps',
    moreFromMicrosoft: 'more-microsoft-365-apps',
    business: 'business-apps',
    customer: 'customer-workspace',
    allApps: 'allapps',
    mos: 'mos-apps',
    core: 'core-apps',
    aad: 'aad-apps',
    lob: 'lob-apps',
    featured: 'featured',
};
export var STORE_APP_ID = 'f3a6e67f-850d-4dd9-960a-04c6638ded36';
export var BANNER_ID = 'apps-module-banner';
export var IMMERSIVEBIZCHAT_APP_ID = 'd870f6cd-4aa5-4d42-9626-ab690c041429';
// TODO 8498663 remove MORE_MICROSOFT_APPS once relocateFamilySafetyAppEnabled goes to 100% WW
export var MORE_MICROSOFT_APPS = [
    'Bing',
    'MSN',
    'Privacy',
    'Rewards',
];
export var UPDATED_MORE_MICROSOFT_APPS = [
    'Bing',
    'MSN',
    'Privacy',
    'Rewards',
    'FamilySafety',
];
export var COMMERCIAL_CORE_APPS_ID = [
    'ShellSkypeTeams',
    'ShellWordOnline',
    'ShellExcelOnline',
    'ShellPowerPointOnline',
    'ShellMail',
    'ShellDocuments',
    'ShellOneNoteOnline',
];
export var CONSUMER_CORE_APPS_ID = [
    'ShellWordOnline',
    'ShellExcelOnline',
    'ShellPowerPointOnline',
    'ShellDocuments',
    'ShellMail',
    'ShellTeams',
    'ShellClipchamp',
];
export var AppType;
(function (AppType) {
    AppType["Mos"] = "LaunchPage";
    AppType["FirstParty"] = "FirstParty";
    AppType["Dynamics"] = "Dynamics";
    AppType["AAD"] = "Graph";
    AppType["LOB"] = "LineOfBusiness";
    AppType["Unknown"] = "Unknown";
})(AppType || (AppType = {}));
export var SectionName;
(function (SectionName) {
    SectionName["Mos"] = "mos";
    SectionName["Core"] = "core";
    SectionName["Collection"] = "collection";
    SectionName["Category"] = "category";
    SectionName["AllApps"] = "allapps";
    SectionName["Featured"] = "featured";
})(SectionName || (SectionName = {}));
export var PageLevel;
(function (PageLevel) {
    PageLevel["L1"] = "L1";
    PageLevel["L2"] = "L2";
})(PageLevel || (PageLevel = {}));
export var copilotAppGalleryItem = function (isBCAIS, copilotNewBCBIconEnabled) {
    var _a;
    return {
        DisplayName: 'Copilot',
        SubTitle: 'Copilot',
        Description: 'M365 Copilot App',
        Id: IMMERSIVEBIZCHAT_APP_ID,
        Text: 'Copilot',
        Title: 'Copilot',
        Url: 'https://outlook.office.com/hosted/semanticoverview?hostApp=hub&isanonymous=true&features=immersive-bizchat-feature,immersive-bizchat-standalone,immersive-disable-bizchat-feed-homepage',
        InAppNav: false,
        ThirdPartyIcon: isBCAIS && copilotNewBCBIconEnabled
            ? 'https://res.cdn.office.net/officehub/officestartresources/copilot-m365-icon-color.svg'
            : 'https://res.cdn.office.net/officehub/officestartresources/copilot_24_light_and_dark.svg ',
        AppId: IMMERSIVEBIZCHAT_APP_ID,
        CollectorId: AppType.FirstParty,
        Referral: 'Copilot App',
        Categories: (_a = {},
            _a[CategoryType.Productivity] = 1,
            _a[CategoryType.Utilities] = 1,
            _a),
        LearnMoreLink: 'https://learn.microsoft.com/en-us/copilot/microsoft-365/',
        id: IMMERSIVEBIZCHAT_APP_ID,
        //unused mandatory fields
        Color: '',
        IconUnicodeCodepointCssClass: '',
        IconFont: undefined,
        Size: 0,
        SubText: 'Copilot',
        ClickCount: 0,
        FirstOccurrence: 0,
        LastOccurrence: 0,
        IsThirdParty: false,
        IsNativeClientOnlyApp: false,
        HideTile: false,
        ChangeColorInDarkMode: false,
    };
};
export var Source;
(function (Source) {
    Source["contextMenu"] = "contextMenu";
    Source["dialogButton"] = "dialogButton";
    Source["dialogBody"] = "dialogBody";
    Source["directLink"] = "directLink";
})(Source || (Source = {}));
export var IconSize;
(function (IconSize) {
    IconSize["xsmall"] = "xsmall";
    IconSize["small"] = "small";
    IconSize["regular"] = "regular";
    IconSize["medium"] = "medium";
})(IconSize || (IconSize = {}));
//# sourceMappingURL=app-gallery.constants.js.map